import { currentEnv } from "./env.ts";

export const ENVS = {
	localhost: {
		VITE_ENV: "dev",
		VITE_APP_URL: "dev-gallery.konfhub.com",
		VITE_API_URL: "https://dev-api.konfhub.com",
		VITE_APP_BUCKET_NAME: "kh-gallery-dev",
		VITE_CENTRAL_LOGIN_URL: "https://dev-accounts.konfhub.com",
		VITE_AWS_PROJECT_REGION: "ap-southeast-1",
		VITE_AWS_COGNITO_IDENTITY_POOL_ID: "ap-southeast-1:9a5331da-329a-497d-be61-15668b42bf8f",
		VITE_AWS_COGNITO_REGION: "ap-southeast-1",
		VITE_AWS_USER_POOLS_ID: "ap-southeast-1_f6tfrmIsS",
		VITE_OAUTH_DOMAIN: "dev-auth.konfhub.com",
		VITE_AWS_USER_POOLS_WEB_CLIENT_ID: "1cum79568pe0u434ek1d5kin9a",
		VITE_AWS_GALLERY_CLIENT_ID: "43iu26dgn6u0cg28jo3r0ne2qh",
		VITE_AWS_APPSYNC_GRAPHQLENDPOINT: "https://dev-attendee-api.konfhub.com/graphql",
		VITE_HOST_NAME: "localhost",
		VITE_SENTRY_AUTH_TOKEN:
			"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",
		VITE_GRAPHQL_PUBLIC_API_KEY: "da2-r3oju7njvrbhhed2egv3nel6jy",
		VITE_EVENT_ID: "c04761fb-dff2-417d-9c65-31198faf925b",
		VITE_X_API_KEY: "c8e680f8-30c3-4bc4-8e91-1c3ba5fc2a77"
	},
	dev: {
		VITE_ENV: "dev",
		VITE_APP_URL: "dev-gallery.konfhub.com",
		VITE_API_URL: "https://dev-api.konfhub.com",
		VITE_APP_BUCKET_NAME: "kh-gallery-dev",
		VITE_CENTRAL_LOGIN_URL: "https://dev-accounts.konfhub.com",
		VITE_AWS_PROJECT_REGION: "ap-southeast-1",
		VITE_AWS_COGNITO_IDENTITY_POOL_ID: "ap-southeast-1:9a5331da-329a-497d-be61-15668b42bf8f",
		VITE_AWS_COGNITO_REGION: "ap-southeast-1",
		VITE_AWS_USER_POOLS_ID: "ap-southeast-1_f6tfrmIsS",
		VITE_OAUTH_DOMAIN: "dev-auth.konfhub.com",
		VITE_AWS_USER_POOLS_WEB_CLIENT_ID: "1cum79568pe0u434ek1d5kin9a",
		VITE_AWS_GALLERY_CLIENT_ID: "43iu26dgn6u0cg28jo3r0ne2qh",
		VITE_AWS_APPSYNC_GRAPHQLENDPOINT: "https://dev-attendee-api.konfhub.com/graphql",
		VITE_HOST_NAME: "konfhub.com",
		VITE_SENTRY_AUTH_TOKEN:
			"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",
		VITE_GRAPHQL_PUBLIC_API_KEY: "da2-r3oju7njvrbhhed2egv3nel6jy",
		VITE_EVENT_ID: "c04761fb-dff2-417d-9c65-31198faf925b",
		VITE_X_API_KEY: "c8e680f8-30c3-4bc4-8e91-1c3ba5fc2a77"
	},
	"pre-prod": {
		VITE_ENV: "pre-prod",
		VITE_APP_URL: "pre-prod-gallery.konfhub.me",
		VITE_API_URL: "https://pre-prod-api.konfhub.me",
		VITE_APP_BUCKET_NAME: "kh-gallery-pre-prod",
		VITE_CENTRAL_LOGIN_URL: "https://pre-prod-accounts.konfhub.me",
		VITE_AWS_PROJECT_REGION: "us-east-2",
		VITE_AWS_COGNITO_IDENTITY_POOL_ID: "us-east-2:663b7319-9305-48f7-aa41-dfbacf0e346b",
		VITE_AWS_COGNITO_REGION: "us-east-2",
		VITE_AWS_USER_POOLS_ID: "us-east-2_uJK6um78b",
		VITE_OAUTH_DOMAIN: "pre-prod-auth.konfhub.me",
		VITE_AWS_USER_POOLS_WEB_CLIENT_ID: "77bohmtvsrngh0kc7nqqblitvv",
		VITE_AWS_GALLERY_CLIENT_ID: "43iu26dgn6u0cg28jo3r0ne2qh",
		VITE_AWS_APPSYNC_GRAPHQLENDPOINT: "https://pre-prod-attendee-api.konfhub.me/graphql",
		VITE_HOST_NAME: "konfhub.me",
		VITE_SENTRY_AUTH_TOKEN:
			"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",
		VITE_GRAPHQL_PUBLIC_API_KEY: "da2-r3oju7njvrbhhed2egv3nel6jy",
		VITE_EVENT_ID: "c04761fb-dff2-417d-9c65-31198faf925b",
		VITE_X_API_KEY: "c8e680f8-30c3-4bc4-8e91-1c3ba5fc2a77"
	},
	staging: {
		VITE_ENV: "staging",
		VITE_APP_URL: "staging-gallery.konfhub.com",
		VITE_API_URL: "https://staging-api.konfhub.com",
		VITE_APP_BUCKET_NAME: "kh-gallery-staging",
		VITE_CENTRAL_LOGIN_URL: "https://staging-accounts.konfhub.com",
		VITE_AWS_PROJECT_REGION: "us-east-1",
		VITE_AWS_COGNITO_IDENTITY_POOL_ID: "us-east-1:337d5ba7-28cf-4e5a-b991-6c66fdfa215d",
		VITE_AWS_COGNITO_REGION: "us-east-1",
		VITE_AWS_USER_POOLS_ID: "us-east-1_Qt5m915Di",
		VITE_OAUTH_DOMAIN: "kh-staging-auth.konfhub.com",
		VITE_AWS_USER_POOLS_WEB_CLIENT_ID: "11h7864bll3sgmtb93qb5coeg3",
		VITE_AWS_GALLERY_CLIENT_ID: "7n35j045e6d7l52k82kv3hkhpo",
		VITE_AWS_APPSYNC_GRAPHQLENDPOINT: "https://staging-attendee-api.konfhub.com/graphql",
		VITE_HOST_NAME: "konfhub.com",
		VITE_SENTRY_AUTH_TOKEN:
			"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",
		VITE_GRAPHQL_PUBLIC_API_KEY: "da2-np4ggmvkvvaqpapn73xvm2lchq",
		VITE_EVENT_ID: "c2ae576a-7a6e-48f6-89c2-2a672a82e943",
		VITE_X_API_KEY: "15533343-74c6-4970-a63e-f87edffabbeb"
	},
	prod: {
		VITE_ENV: "prod",
		VITE_APP_URL: "gallery.konfhub.com",
		VITE_API_URL: "https://api.konfhub.com",
		VITE_APP_BUCKET_NAME: "kh-gallery-prod",
		VITE_CENTRAL_LOGIN_URL: "https://accounts.konfhub.com",
		VITE_AWS_PROJECT_REGION: "ap-south-1",
		VITE_AWS_COGNITO_IDENTITY_POOL_ID: "ap-south-1:0bf02d86-5b7b-4665-964d-cb52f756903b",
		VITE_AWS_COGNITO_REGION: "ap-south-1",
		VITE_AWS_USER_POOLS_ID: "ap-south-1_acJo3XGbL",
		VITE_OAUTH_DOMAIN: "auth.konfhub.com",
		VITE_AWS_USER_POOLS_WEB_CLIENT_ID: "5jf10rk2c0muftotp1iu2ucup0",
		VITE_AWS_GALLERY_CLIENT_ID: "73pqaf818vaphm8g51got9dl2s",
		VITE_AWS_APPSYNC_GRAPHQLENDPOINT: "https://attendee-api.konfhub.com/graphql",
		VITE_HOST_NAME: "konfhub.com",
		VITE_SENTRY_AUTH_TOKEN:
			"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",
		VITE_GRAPHQL_PUBLIC_API_KEY: "da2-5uz4kjc3z5gj7gspqffvtcwuyq",
		VITE_EVENT_ID: "03cba435-7384-4148-992e-e5e4937fd333",
		VITE_X_API_KEY: "f0dc80af-4e32-480b-a5c3-fe97a7baf8d6"
	}
};

const getEnvName = () => {
	if (typeof window !== "undefined") {
		const currentUrl = window?.location?.hostname || "localhost";
		if (currentUrl?.includes("dev-gallery.konfhub.com")) {
			return "dev";
		}
		if (currentUrl?.includes("staging-gallery.konfhub.com")) {
			return "staging";
		}
		if (currentUrl?.includes("gallery.konfhub.com")) {
			return "prod";
		}
		if (currentUrl?.includes("pre-prod-gallery.konfhub.me")) {
			return "pre-prod";
		}
		if (
			currentUrl?.includes("localhost") ||
			currentUrl?.includes("127.0.0.1") ||
			currentUrl?.includes("192.168.1.11")
		) {
			return "localhost";
		}
	} else {
		return currentEnv;
	}
};

export const ENV_NAME = getEnvName();
export const isKHDomain = getEnvName() !== "custom";
